<template>
  <v-container :class="isSPSize ? 'sp' : ''">
    <v-row>
      <v-col cols="12">
        <h1 :class="h1Style" class="title-border">
          プライバシーポリシー
        </h1>
      </v-col>
      <v-col cols="12">
        <p>
          株式会社Attic Start（以下「当社」といいます。）は、当社の提供するサービス（以下「本件サービス」といいます。）におけるユーザーの個人情報（個人情報保護法第２条第１項の定義によります。）を含む利用者情報の取り扱いについて、プライバシーポリシー（以下「本ポリシー」といいます。）を定めます。<br />
          本件サービスをご利用になる前に、必ず、本ポリシーをご一読ください。本件サービスのご利用にあたっては、本ポリシーの記載事項についての同意が必要であり、ご同意いただけない場合は、本件サービスをご利用いただけません。尚、本ポリシー中の語句の定義については、本件規約をご参照ください。
        </p>
        <p>
          １　収集する利用者情報及び収集方法
        </p>
        <p>
          本ポリシーにおいて、「利用者情報」とは、ユーザーの識別に係る情報、通信サービス上の行動履歴、その他ユーザーのスマートフォン、ＰＣ等の端末に関連して生成または蓄積された情報であって、本ポリシーに基づき当社が収集するものを意味します。<br>
          本件サービスにおいて当社が収集する利用者情報は、その収集方法に応じて、以下のようなものとなります。
        </p>
        <p class="mb-2">
          (1)　ユーザーから提供される情報
        </p>
        <p>
          ユーザーが本件サービスを利用するために、以下の情報を提供していただくことになります。
        </p>
        <ul class="mb-3">
          <li>氏名、出身国、居住地域、電話番号、メールアドレス、生年月日、性別、写真</li>
          <li>旅行出発地、旅行先、旅行期間、行動可能地域</li>
          <li>興味/関心、好きなもの、使用言語、語学の習得レベル、自己紹介文</li>
          <li>本件サービス利用に伴うフィードバック、感想、レビュー</li>
          <li>その他当社が定める登録フォームにユーザーが入力する情報</li>
        </ul>
        <p class="mb-2">
          (2)　ユーザーが本件サービスの利用において、他のサービスと連携を許可することにより、当該他のサービスから提供される情報
        </p>
        <p>
          ユーザーが、本件サービスを利用するにあたり、ソーシャルネットワークサービス等の外部サービスとの連携を許可した場合には、その許可の際にユーザーが同意した内容に基づき、以下の情報を当該外部サービスから収集する場合があります。
        </p>
        <ul class="mb-3">
          <li>当該外部サービスでユーザーが利用するＩＤ等の識別情報</li>
          <li>その他当該外部サービスのプライバシー設定によりユーザーが連携先に開示を認めた情報</li>
        </ul>
        <p class="mb-2">
          (3)　ユーザーが本件サービスを利用するにあたって、当社が収集する情報
        </p>
        <p>
          当社は、本件サービスへのアクセス状況やそのご利用方法に関する情報を収集することがあります。これには以下の情報が含まれます。
        </p>
        <ul class="mb-3">
          <li>端末情報</li>
          <li>ログ情報</li>
          <li>Cookie技術を用いて生成された識別情報</li>
          <li>位置情報</li>
          <li>IPアドレス</li>
          <li>チャットでのユーザー同士のやり取り</li>
        </ul>
        <p>
          ２　利用目的
        </p>
        <p>
          収集した利用情報は、以下の目的に使用します。
        </p>
        <p class="mb-2">
          (1)　本件サービスの提供、改善及び開発
        </p>
        <ul class="mb-3">
          <li>本件サービスの提供、利用登録、本人確認等のため</li>
          <li>他のユーザー（旅行者またはローカル）とのマッチングに使用するため</li>
          <li>本件サービスの維持、保護、メンテナンス及び本件サービスの品質の向上のため</li>
          <li>本件サービスを安全に提供するため（利用規約に違反しているユーザーを発見して当該ユーザーに通知をすること、本件サービスの悪用、詐欺、不正アクセス等の不正行為を調査、検出、予防すること等の対応が含まれます。）</li>
          <li>新たなサービス、新機能の開発のため</li>
          <li>システムの維持、不具合等への対応のため</li>
          <li>アンケートの実施のため</li>
          <li>本件サービスに関する案内、お問い合わせ等への対応のため</li>
          <li>本件サービスに関連するプロモーション、アフターサービス、新商品・新サービスに関する情報のお知らせのため</li>
          <li>本件サービスと関連する第三者に関する情報（広告等を含みます。）を配信等するため</li>
          <li>本件サービスに関する規約等の変更などを通知するため</li>
          <li>詐欺、悪用、不正使用、スパム等の有害行為または利用規約に違反する行為の発見、防止、対応のため</li>
          <li>上記の利用目的に付随する利用目的のため</li>
        </ul>
        <p class="mb-2">
          (2)　広告、マーケティングおよびデータ解析に基づくサービスの開発
        </p>
        <p>
          収集した情報は、個人を識別できない形式に加工した統計データを作成し、マーケティング、コンサルティング、広告表示、広告配信等の目的で、当該統計データを解析し、利用することがあります。尚、個人を識別できない形式に加工して利用する情報は、以下のとおりです。
        </p>
        <ul class="mb-3">
          <li>端末情報</li>
          <li>ログ情報</li>
          <li>Cookie及びCookie技術を用いて生成された情報</li>
          <li>位置情報</li>
          <li>IPアドレス</li>
          <li>利用言語</li>
          <li>出身国</li>
          <li>居住地域</li>
          <li>年齢、生年月日</li>
          <li>性別</li>
          <li>メール、チャット等のやりとりの内容</li>
          <li>フィードバック、感想、レビュー</li>
          <li>その他当社の登録フォームやお問い合わせフォーム等にユーザーが登録する情報</li>
        </ul>
        <p>
          ３　利用中止要請の方法
        </p>
        <p>
          ユーザーは、当社所定の方法により、利用者情報の全部または一部についてその利用の停止を求めることができ、この場合、当社は速やかに、当社の定めるところに従い、その利用を停止します。なお、利用者情報の項目によっては、その収集または利用が本件サービスの前提となるため、当社所定の方法により本件サービスを退会した場合に限り、当社はその収集を停止します。
        </p>
        <p>
          ４　利用者情報の第三者提供に関する同意等
        </p>
        <p>
          ユーザーには、本件サービスを利用するに際して、以下の利用者情報について、当社から第三者に対し、利用者情報が提供されることについて、あらかじめ同意するものとします。<br />
          ユーザーのＩＤ、ニックネーム、写真、性別、年齢に基づく世代、旅行出発地、居住地域、出身国、行動可能地域、興味／関心、好きなもの、使用言語、語学の習得レベル、自己紹介文、過去の本件サービスの利用履歴、その他ユーザーが許諾した情報
        </p>
        <p>
          ５　個人情報の第三者への提供
        </p>
        <p>
          当社は、利用者情報のうち、個人情報について、個人情報保護法その他の法令に基づき開示が認められる場合を除くほか、あらかじめユーザーの同意を得ないで、第三者に提供しません。但し、次に掲げる場合はこの限りではありません。
        </p>
        <p class="mb-2">
          (1)　当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合（広告配信、データ分析、マーケティング等）<br />
          (2)　合併その他の事由による事業の承継に伴って個人情報が提供される場合<br />
          (3)　国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ユーザーの同意を得ることによって当該事務の遂行に支障を及ぼすおそれがある場合<br />
          (4)　その他、個人情報保護法その他の法令で認められる場合<br />
        </p>
        <p>
          ６　個人情報保護のための安全管理
        </p>
        <p>
          当社は、当社が取得した個人情報の漏洩防止、安全管理等のために、当社が取得した個人情報を保護するための規定等を定め、従業員に周知・徹底する等、必要な安全管理措置の維持・向上に努めます。但し、これらの安全管理措置は、個人情報の漏洩等が起こり得ないことを保証するものではありません。当社の適切な運用にも拘わらず、第三者の不正行為等により生じた事故等について当社は一切責任を負いません。
        </p>
        <p>
          ７　個人情報の開示
        </p>
        <p>
          当社は、ユーザーから、個人情報保護法の定めに基づき個人情報の開示を求められたときは、本人確認の上（本人確認書類のご提示をお願いする場合があります。）、ユーザーに対し、遅滞なく開示を行います（当該個人情報が存在しないときにはその旨を通知いたします。）。但し、個人情報保護法その他の法令により、当社が開示の義務を負わない場合は、この限りではありません。なお、個人情報の開示につきましては、手数料（1件あたり５００円）及び実費を請求させていただきます。
        </p>
        <p>
          ８　個人情報の訂正及び利用停止等
        </p>
        <p class="mb-2">
          (1)　個人情報の訂正及び利用停止
        </p>
        <p>
          当社は、ユーザーから、①個人情報が真実でないという理由によって個人情報保護法の定めに基づきその内容の訂正を求められた場合、及び②あらかじめ公表された利用目的の範囲を超えて取り扱われているという理由または偽りその他不正の手段により収集されたものであるという理由により、個人情報保護法の定めに基づきその利用の停止を求められた場合、③ユーザーに関する保有個人データが第三者提供の制限に関する個人情報保護法の定めに違反して第三者に提供されているという理由によって、第三者への提供の停止を求められた場合には、本人確認の上（本人確認書類のご提示をお願いする場合があります。）、遅滞なく必要な調査を行い、その結果に基づき、個人情報の内容の訂正、利用停止、または第三者への提供の停止を行い、その旨をユーザーに通知します。なお、合理的な理由に基づいて訂正、利用停止、または第三者への提供の停止を行わない旨の決定をしたときは、ユーザーに対してその旨を通知いたします。
        </p>
        <p class="mb-2">
          (2)　個人情報の消去
        </p>
        <p>
          当社は、ユーザーから、ユーザーの個人情報について消去を求められた場合、当社が当該請求に応じる必要があると判断した場合は、本人確認の上（本人確認書類のご提示をお願いする場合があります。）、個人情報の消去を行い、その旨をユーザーに通知します。
        </p>
        <p class="mb-2">
          (3)　適用除外
        </p>
        <p>
          個人情報保護法その他の法令により、当社が訂正等又は利用停止等の義務を負わない場合は、前2項の規定は適用されません。
        </p>
        <p>
          ９　お問い合わせ窓口
        </p>
        <p>
          ご意見、ご質問、苦情のお申出その他利用者情報の取扱いに関するお問い合わせは、下記の窓口までお願いいたします。
        </p>
        <p>
          住所：〒102-0093 東京都千代田区平河町2-5-3 Nagatacho GRID 5F Midori.so<br>
          株式会社Attic Start カスタマーサポートセンター（担当：Keisuke Tomida）<br>
          E-mail：<a href="mailto:support@paikeout.com">support@paikeout.com</a>
        </p>
        <p>
          １０　本ポリシーの変更手続
        </p>
        <p>
          当社は、利用者情報の取扱いに関する運用状況を適宜見直し、継続的な改善に努めるものとし、必要に応じて、本ポリシーを変更することがあります。変更した場合には、当社所定の方法でユーザーに通知いたします。改定後に本件サービスを利用した場合、変更後のポリシーに同意されたものとみなされます。但し、法令上ユーザーの同意が必要となるような内容の変更の場合は、当社所定の方法でユーザーの同意を得るものとします。
        </p>
        <p class="text-right">以上</p>
        <p>
          作成日 2020年3月27日
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-btn
          rounded
          large
          dark
          align-items="center"
          color="gray"
          width="250"
          class="font-weight-bold text-capitalize"
          @click="$router.go(-1)"
        >
          Back
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    h1Style() {
      return this.isSPSize
        ? 'font-h1-sp font-weight-bold mb-3'
        : 'font-h1-pc font-weight-bold mb-5'
    },
    isSPSize() {
      return this.$vuetify.breakpoint.name === 'xs'
    },
  },
}
</script>

<style lang="stylus" scoped>
p
  line-height 1.5
  font-size 15px

.sp
  p, ul, ol
    font-size 12px
</style>